import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CustomIcon from '../../common/CustomIcon';
import GroupList from './GroupList';
import { CAROUSEL } from '../../../const';
import $ from 'jquery';

class GroupsCarousel extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.state = {
      carouselPosition: 0
    };
  }

  static propTypes = {
    groups: PropTypes.array,
    currentSelection: PropTypes.object,
    hasMultipleChoose: PropTypes.any,
    selectGroup: PropTypes.any
  };

  componentDidUpdate(prevProps, prevState) {
    const { carouselPosition } = this.state;
    const { currentSelection, groups, hasMultipleChoose } = this.props;

    if (groups && currentSelection && prevState.carouselPosition === carouselPosition) {
      let newPosition = this.getSelectedGroupInCarousel(currentSelection);
      let carouselSize = hasMultipleChoose ? CAROUSEL.PARTIAL_SIZE : CAROUSEL.FULL_SIZE;
      if (newPosition !== carouselPosition && groups && groups.length >= carouselSize) {
        this.moveCarousel(newPosition);
      }
    }
  }

  getSelectedGroupInCarousel(currentSelection) {
    const { groups, hasMultipleChoose } = this.props;
    let position = 0;
    if (groups) {
      if (currentSelection.isGroup) {
        groups.forEach((group, index) => {
          if (group.id === currentSelection.id) {
            position = index;
          }
        });
      }
      let carouselSize = hasMultipleChoose ? CAROUSEL.PARTIAL_SIZE : CAROUSEL.FULL_SIZE;
      if (position >= groups.length - carouselSize) {
        position = groups.length - carouselSize;
      }
    }
    return position;
  }

  handleCarouselRight() {
    const { hasMultipleChoose } = this.props;
    const { carouselPosition } = this.state;
    const { groups } = this.props;
    let nextPos = carouselPosition + 1;
    let carouselSize = hasMultipleChoose ? CAROUSEL.PARTIAL_SIZE : CAROUSEL.FULL_SIZE;
    if (groups && groups.length >= nextPos + carouselSize) {
      this.moveCarousel(nextPos);
    }
  }

  handleCarouselLeft() {
    const { carouselPosition } = this.state;
    let nextPos = carouselPosition - 1;
    if (nextPos >= 0) {
      this.moveCarousel(nextPos);
    }
  }

  moveCarousel(nextPos) {
    $('.carousel').css('left', `${nextPos * -CAROUSEL.ITEM.SIZE}px`);
    this.setState({ carouselPosition: nextPos });
  }

  selectGroup(group) {
    const { selectGroup } = this.props;
    selectGroup(group);
  }

  renderCarousel() {
    const { groups, currentSelection } = this.props;
    let carouselSize = '';
    if (groups.length === 1) {
      carouselSize = 'one-item';
    } else if (groups.length === 2) {
      carouselSize = 'two-items';
    }
    return (
      <div className={`carousel-row ${carouselSize}`}>
        <GroupList groups={groups} currentSelection={currentSelection} selectGroup={this.selectGroup.bind(this)} />
      </div>
    );
  }

  render() {
    let { groups, hasMultipleChoose } = this.props;
    const { carouselPosition } = this.state;

    if (!groups || groups.length === 0) return <div />;
    let carouselSize = hasMultipleChoose ? CAROUSEL.PARTIAL_SIZE : CAROUSEL.FULL_SIZE;
    let hideLeft = carouselPosition === 0 || groups.length < carouselSize ? 'none' : '';
    let hideRight = '';
    if (groups) {
      hideRight = carouselPosition === groups.length - carouselSize || groups.length < carouselSize ? 'none' : '';
    }
    hasMultipleChoose = hasMultipleChoose ? 'multiple-choose' : '';
    return (
      <div className={`carousel-container ${hasMultipleChoose}`}>
        <div className={`carousel-separator left ${hideLeft}`} onClick={this.handleCarouselLeft.bind(this)}>
          <CustomIcon name="left-chevron" size={14} />
        </div>

        {this.renderCarousel()}

        <div className={`carousel-separator ${hideRight}`} onClick={this.handleCarouselRight.bind(this)}>
          <CustomIcon name="right-chevron" size={14} />
        </div>
      </div>
    );
  }
}

export default connect()(GroupsCarousel);
